import { createFileRoute } from "@tanstack/react-router";
import { MellanoPaintingControlChartsView } from "src/tenantCustomizations/tenants/mellano/views/spc/MellanoPaintingControlChartsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/paintingControlCharts")({
	staticData: { title: "Maalaus", legacyViewKey: "mellanoPaintingControlChartsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoPaintingControlChartsView />;
}
